import { Inject, Injectable } from '@angular/core';
import {enc,pad,mode, AES, SHA256 } from 'crypto-js';
import { APP_SETTINGS, AppSettings } from '../settings';
import CryptoJS from "crypto-js";
@Injectable({
    providedIn: 'root'
})
export class EncryptionService {
    // private readonly SALT = enc.Base64.parse('SXZhbiBNZWR2ZWRldg==');
    // private readonly ITERATIONS = 1000;

    constructor(@Inject(APP_SETTINGS) 
    private settings: AppSettings) { }

  encryptUsingAES_256(input) {
        try {
            let _key = enc.Hex.parse('842a357c4b385726090aa184b75b691075da95e6ddd4eb40');
            let _iv = enc.Hex.parse('53471a3a3623160b53471a3a3623160b');
            let encrypted = AES.encrypt(
              enc.Utf8.parse(input), _key, {
                keySize: 128 / 8,
                iv: _iv,
                mode: mode.CBC,
                padding: pad.Pkcs7
              });
            const encryptedData = enc.Base64.stringify(encrypted.ciphertext);
            return encryptedData;
        } catch (e) {
          console.log("encryptUsingAES_256 :-",e); // Handle or log the error appropriately
          return null;
        }
        
  }
  decryptUsingAES_256(input) {
        try {
            if(input){
              let _key = enc.Hex.parse('842a357c4b385726090aa184b75b691075da95e6ddd4eb40');
              let _iv = enc.Hex.parse('53471a3a3623160b53471a3a3623160b');
          
              const decrypted = AES.decrypt(input, _key, {
                iv: _iv
            });
      
              return decrypted.toString(enc.Utf8);
            }
            else{
              return null;
            }
           
        } catch (e) {
          console.log("decryptUsingAES_256:- ",e); // Handle or log the error appropriately
          return null;
        }
        
  }
  decryptingClientMobileString(mobileNumber: string): string {
    let decryptValue = '';
    try {
      if (mobileNumber) {
        const token =
          '576E5A7234753778217A25432A462D4A614E645267556B58703273357638792F';
        const key = CryptoJS.enc.Utf8.parse(token.substring(0, 32));
        const iv = CryptoJS.enc.Utf8.parse(token.substring(0, 16));

        // Parse the Base64 ciphertext properly
        const encryptedWords = CryptoJS.enc.Base64.parse(mobileNumber);

        // Create a CipherParams object safely
        const cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: encryptedWords,
        });

        // Decrypt using AES-CBC + PKCS7
        const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });

        decryptValue = decrypted.toString(CryptoJS.enc.Utf8);
      }
    } catch (e) {
      console.error('DecryptingClientMobileString Error:', e);
    }
    return decryptValue;
  }
  hashSHA256SecretKey(input: string): string {
    return SHA256(input).toString(enc.Hex);
  }
}
